<script setup lang="ts">
import { ru } from '@nuxt/ui/locale'

import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const is404 = computed(() => props.error?.status === 404)

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <UApp :locale="ru" :toaster="{ position: 'top-right' }">
    <NuxtLayout>
      <div v-if="is404" class="flex flex-col items-center justify-center px-4 py-20 text-center">
        <img src="/404.svg" alt="404" class="mb-8 w-full max-w-140">

        <h1 class="mb-4 text-2xl font-bold">
          Такой страницы нет
        </h1>

        <p class="mb-10 max-w-140 text-gray-500">
          Похоже, ссылка устарела или в адресе закралась ошибка.
        </p>

        <UButton
          to="/"
          size="xl"
          external
          @click="handleError"
        >
          перейти на главную страницу
        </UButton>
      </div>

      <div v-else class="flex flex-col items-center justify-center px-4 py-20 text-center">
        <h1 class="mb-4 text-2xl font-bold">
          Произошла ошибка {{ error.status }}
        </h1>
        <p class="mb-10 max-w-140 text-gray-500">
          {{ error.message || 'Что-то пошло не так' }}
        </p>
        <UButton
          size="xl"
          @click="handleError"
        >
          Вернуться на главную
        </UButton>
      </div>
    </NuxtLayout>
  </UApp>
</template>
